<template lang="html">
  <div class="" @click="payBtn">
    <van-loading size="24px" vertical style="padding-top:50%;">
      准备支付...
    </van-loading>
  </div>
</template>

<script>
  import Vue from 'vue'
  // import wx from 'weixin-js-sdk'
  const wx = require('weixin-js-sdk')
  import { Loading } from 'vant'
  import router from '../router'
  import store from '../store/index'
  Vue.use(Loading)
  export default {
    data () {
      return {
        wxOrder: null
      }
    },
    watch: {
      wxOrder: function (newVal, oldVal) {
        if (newVal != oldVal) {
          this.choosePay()
        }
      }
    },
    methods: {
      payBtn () {
        this.choosePay()
      },
      choosePay () {
        let wxOrder = this.wxOrder
        wx.chooseWXPay ({
          timestamp: wxOrder.timestamp,
          nonceStr: wxOrder.nonceStr,
          package: wxOrder.package,
          signType: wxOrder.signType,
          paySign: wxOrder.paySign,
          cancel () {
            store.commit(
              'setPaymentResult', {success: false, message: '支付已取消'})
            // router.replace({path: store.state.productUrl})
            router.replace({path: store.state.payFailUrl})
          },
          success () {
            store.commit(
              'setPaymentResult', {success: true, message: '支付成功'})
            router.replace({path: store.state.productUrl})
          }
        })
      },
      payOrder (applabel, classname, objectid) {
        let that = this
        let data = {
          applabel: applabel,
          classname: classname,
          objectid: objectid,
          payment: 'wechat',
          tradetype: 'JSAPI'
        }
        that.$api.order.pay(data).then(res => {
          window.console.log("新订单已经生成")
          window.console.log(res)
          that.wxOrder = res.data
          // that.choosePay(res.data)
        })
        .catch(error => {
          window.console.log("订单生成失败")
          window.console.log(error)
        })
      },
    },
    mounted () {
      let params = {url: location.href.split('#')[0]}
      this.$api.libs.getJSApiConfig(params).then(res => {
        // 开始注入微信jsapi权限验证配置
        wx.config({
          debug: false,
          appId: res.data.appid,
          timestamp: res.data.timestamp,
          nonceStr: res.data.noncestr,
          signature: res.data.signature,
          jsApiList: ['chooseWXPay']
        })
      })
      let that = this
      wx.ready(function(){
        window.console.log("微信JSAPI接口已经验证完毕")
        window.console.log(that.$route.query)
        that.payOrder(
          that.$route.query.applabel,
          that.$route.query.classname,
          that.$route.query.objectid)
      });
    }
  }
</script>

<style lang="css" scoped>
</style>
